// Desglosa los pagos de una orden por método/moneda (montos en USD).
// Prioriza los cobros registrados desde Órdenes (notas [PAGO: ...] / [PAGO PARCIAL: ...]),
// ya que cash_amount/transfer_amount acumulan USD y COP juntos y no distinguen la moneda.
const PAYMENT_ENTRY_REGEX = /\[PAGO(?: PARCIAL)?:.*?-\s*\$([\d.]+) USD \((Efectivo USD|Efectivo COP|Transferencia USD|Transferencia COP|Tarjeta)\)/g;

export const getOrderPaymentBreakdown = (order, exchangeRate) => {
    // efectivo_cop / transferencia_cop: pesos reales, con la tasa usada al momento de cada cobro
    const stats = { efectivo: 0, transferencia: 0, tarjeta: 0, efectivo_cop_in_usd: 0, transferencia_cop_in_usd: 0, efectivo_cop: 0, transferencia_cop: 0 };
    const finish = () => {
        stats.efectivo_cop = stats.efectivo_cop_in_usd * exchangeRate;
        stats.transferencia_cop = stats.transferencia_cop_in_usd * exchangeRate;
        return stats;
    };

    // Reporte de caja: el backend envía solo los cobros hechos en ESA caja
    // (una orden cobrada en partes en distintos turnos no se duplica)
    if (Array.isArray(order.shift_payments)) {
        order.shift_payments.forEach(({ method, amount, amount_cop }) => {
            const value = parseFloat(amount) || 0;
            // Cobros antiguos no guardaron los pesos: se estiman con la tasa actual
            const cop = amount_cop !== null && amount_cop !== undefined ? parseFloat(amount_cop) : value * exchangeRate;
            if (method === 'efectivo') stats.efectivo += value;
            else if (method === 'efectivo_cop') { stats.efectivo_cop_in_usd += value; stats.efectivo_cop += cop; }
            else if (method === 'transferencia') stats.transferencia += value;
            else if (method === 'transferencia_cop') { stats.transferencia_cop_in_usd += value; stats.transferencia_cop += cop; }
            else stats.tarjeta += value;
        });
        return stats;
    }

    const notes = order.notes || '';

    const entries = [...notes.matchAll(PAYMENT_ENTRY_REGEX)];
    if (entries.length > 0) {
        entries.forEach(([, amount, label]) => {
            const value = parseFloat(amount) || 0;
            if (label === 'Efectivo USD') stats.efectivo += value;
            else if (label === 'Efectivo COP') stats.efectivo_cop_in_usd += value;
            else if (label === 'Transferencia USD') stats.transferencia += value;
            else if (label === 'Transferencia COP') stats.transferencia_cop_in_usd += value;
            else stats.tarjeta += value;
        });
        return finish();
    }

    // Lógica anterior (ventas cobradas directamente en el POS)
    const method = String(order.payment_method || order.payment_method_display || '').toLowerCase();
    const total = parseFloat(order.total_amount || order.total || 0);
    const cashAmount = parseFloat(order.cash_amount || 0);
    const transferAmount = parseFloat(order.transfer_amount || 0);

    if (method === 'dividido' && /CASH_USD=|CASH_COP=|TRANSFER_USD=|TRANSFER_COP=/.test(notes)) {
        const cashUsd = notes.match(/CASH_USD=([\d.]+)/);
        const cashCop = notes.match(/CASH_COP=([\d.]+)/);
        const transUsd = notes.match(/TRANSFER_USD=([\d.]+)/);
        const transCop = notes.match(/TRANSFER_COP=([\d.]+)/);
        if (cashUsd) stats.efectivo += parseFloat(cashUsd[1]);
        if (cashCop) stats.efectivo_cop_in_usd += parseFloat(cashCop[1]) / exchangeRate;
        if (transUsd) stats.transferencia += parseFloat(transUsd[1]);
        if (transCop) stats.transferencia_cop_in_usd += parseFloat(transCop[1]) / exchangeRate;
    } else if (method === 'efectivo_cop') {
        stats.efectivo_cop_in_usd += total;
    } else if (method === 'transferencia_cop') {
        stats.transferencia_cop_in_usd += total;
    } else if (cashAmount > 0 || transferAmount > 0) {
        stats.efectivo += cashAmount;
        stats.transferencia += transferAmount;
        const remaining = total - (cashAmount + transferAmount);
        if (remaining > 0.001 && (method.includes('tarjeta') || method.includes('card'))) {
            stats.tarjeta += remaining;
        }
    } else if (method.includes('efectivo') || method === 'cash') {
        stats.efectivo += total;
    } else if (method.includes('transferencia') || method.includes('transfer')) {
        stats.transferencia += total;
    } else if (method.includes('tarjeta') || method.includes('card')) {
        stats.tarjeta += total;
    } else {
        stats.efectivo += total;
    }
    return finish();
};
